import { useEffect, useState } from 'react';
import { motion } from 'framer-motion'
import { END_ANIMATION_PROPERTY, START_ANIMATION_PROPERTY, VIEWPORT_PROPERTY } from 'components/constants/animation-properties';
import Container from 'components/common/Container';
import { jsonAxios } from 'components/axios';
import { ISpecialData } from 'types/special';
import Card from 'components/special/Card';

const Fourth = () => {
    const [list, setList] = useState<ISpecialData[]>([]);

    useEffect(() => {
        init()
    }, [])

    const init = () => {
        jsonAxios.get(`special-rates`).then(res => {
            if (res.data.code === 200) {
                setList(res.data.data.slice(0, 6))
            }
        })
    }

    return (
        <Container className='flex flex-col gap-10'>
            <div>
                <motion.div
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY}
                    className='flex justify-center items-center bg-primary mb-4.5 py-2.5 rounded max-w-[156px] text-white'
                >
                    Special Deals
                </motion.div>
                <motion.h2
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY}
                    className='font-bold text-32 mobile:text-2xl'>
                    펄스온쉽 <span className='text-primary'>특가운임</span>
                </motion.h2>
            </div>
            {

                list.length > 0 ?
                    <div className='tablet:flex tablet:flex-col gap-6 grid grid-cols-[repeat(auto-fill,_minmax(400px,_1fr))]'>
                        {
                            list.map((item, idx) => (
                                <Card item={item} idx={idx} key={idx} />
                            ))
                        }
                    </div> :
                    <div className='flex justify-center items-center w-full h-96'>
                        특가운임 데이터가 없습니다.
                    </div>
            }
        </Container>
    )
}

export default Fourth